import { AlertCircle } from '@/shared/icons/AlertCircle'

import { TErrorMessageProps } from './types'

export const InputErrorMessage = ({ message }: TErrorMessageProps) => {
  return (
    <div className="input-error-message">
      {message && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <div style={{ minWidth: 18, display: 'flex', alignItems: 'center' }}>
            <AlertCircle width={18} height={18} />
          </div>

          <div className="text">{message}</div>
        </div>
      )}
    </div>
  )
}
